// tslint:disable-next-line:import-blacklist
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import { Injectable, Type } from '@angular/core';
import { IDisposable } from './types';
import { takeUntil, take } from "rxjs/operators";

@Injectable()
export class EventBusPipe implements IDisposable {

    public eventSubject: Subject<any>;
    public observers: Map<string, Subscription>;
    public observersDestroy$: Map<string, any>;
    public pipeCode: string;
    private subscription: Subscription;
    private unsubscribe$: Subject<any> = new Subject<void>();;
    private onceSubscription: Subscription;

    constructor(private tokenValue: string, private parentEventPipeList: Array<EventBusPipe>, sub: Subject<any>) {
        this.eventSubject = sub || new BehaviorSubject<any>(null);
        this.subscription = new Subscription();
        this.onceSubscription = new Subscription();
        this.observers = new Map<string, Subscription>();
        this.observersDestroy$ = new Map<string, any>();

        if (this.parentEventPipeList) {
            this.parentEventPipeList.push(this);
        }
    }

    post(bizPara: any) {
        this.eventSubject.next(bizPara);
    }

    subscribe(eventHandler: (value: any) => void): IDisposable {
        this.subscription = this.eventSubject.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
            eventHandler(value);
        });
        return this;
    }

    unSubscribe() {
        if (this.unsubscribe$) {
            this.unsubscribe$.next();
            this.unsubscribe$.complete();
        }

        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }

    }

    complete() {
        this.eventSubject.complete();
    }


    subscribeWithObkey(observerKey: string, eventHandler: (value: any) => void): IDisposable {
        this.unSubscribeWithObkey(observerKey);
        const $destroy = new Subject<any>();
        const sub = this.eventSubject.pipe(takeUntil($destroy)).subscribe((value) => {
            eventHandler(value);
        });
        this.observers.set(observerKey, sub);
        this.observersDestroy$.set(observerKey, $destroy);
        return this;
    }

    /**
     * 取消某观察者的订阅
     * @param observerKey 观察者唯一标识
     */
    unSubscribeWithObkey(observerKey: string) {
        const $obsDestroySub = this.observersDestroy$.get(observerKey);
        if (!!$obsDestroySub) {
            $obsDestroySub.next();
            $obsDestroySub.complete();
            this.observersDestroy$.set(observerKey, null);
        }
        const observer = this.observers.get(observerKey);
        if (observer) {
            observer.unsubscribe();
            this.observers.set(observerKey, null);
        }
    }

    subscribeOnce(eventHandler: (value: any) => void): IDisposable {
        const scription = this.eventSubject.pipe(take(1)).subscribe((value) => {
            eventHandler(value);
        });
        return this;
    }

    // 注销使用once方法注册的订阅。(方法弃用)
    unSubscribeForOnce() {
        this.onceSubscription.unsubscribe();
    }


    matchEmitterToken(tokenValue: string): boolean {
        if (this.tokenValue && tokenValue && this.tokenValue !== tokenValue) {
            return false;
        }
        return true;
    }

    examByTargetToken(tokenValue: string): boolean {
        if (this.tokenValue !== tokenValue) {
            return false;
        }
        return true;
    }

    dispose(subscriber: Subscription): void {
    }
}
